export const ScrollTopOutlet = () => {
  const outletSection = document.getElementById("outlet");
  outletSection.scrollTop = 0;
};
